module.exports = __webpack_public_path__ + "static/media/EU_Wahlen.be7aaa56.png";